import { useContext } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { useGetAccountQuery } from "../../../generated/graphql";
import { colors } from "../../../stitches.config";
import App from "../../App";
import { AuthContext } from "../../Authorization/AuthContext";
import FullPageLoadingScreen from "../../Common/FullPageLoadingScreen";
import BackOffice from "./BackofficeApp";

export default function AccountDashboardShim() {
  const { admin, setAdmin } = useContext(AuthContext);
  const { data, loading } = useGetAccountQuery({
    onCompleted: data => {
      if (admin && data.account) {
        setAdmin({ ...admin, account: data.account });
      }
    },
  });

  if (loading) return <FullPageLoadingScreen />;
  const account = data?.account;
  if (!account)
    return (
      <div style={{ color: colors.contentPrimaryInverted.toString() }}>
        Invalid account
      </div>
    );
  if (!admin?.allowedToViewDashboard)
    return (
      <div style={{ color: colors.contentPrimaryInverted.toString() }}>
        Not allowed
      </div>
    );

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/backoffice" component={BackOffice} />
        <Route component={App} />
      </Switch>
    </BrowserRouter>
  );
}
